import { JsonFetch } from "@roc-digital/mxm-base/logic";

export async function clearCache(): Promise<void> {
  await JsonFetch<void>({
    url: `${process.env.REACT_APP_AUX_API_URL}/admin/clear-cache`
  });
}